import { render, staticRenderFns } from "./UpdateActions.vue?vue&type=template&id=41a0c4a4&scoped=true&"
import script from "./UpdateActions.vue?vue&type=script&lang=js&"
export * from "./UpdateActions.vue?vue&type=script&lang=js&"
import style0 from "./UpdateActions.vue?vue&type=style&index=0&id=41a0c4a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0c4a4",
  null
  
)

export default component.exports